import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

declare interface RouteInfo {
  title?: string;
  text?: string;
  text2?: string;
  img?: string;
  alt?: string;
  href?: string;
}

export const LegislativeContent: RouteInfo[] = [
  {
    title: 'Legislative & Economic Forecast',
    text: 'The CHCC’s Legislative and Economic Forecast brings together economic and legislative leaders from throughout California, offering specific and reliable insights into next year’s economy and legislative issues impacting our economy and our diverse and small business communities. The annual forecast provides a timely look at California’s economic trajectory and the economic and legislative trends shaping California’s economic and political landscape for the coming year.',
    text2:
      'Public, private, and nonprofit participants will engage in dynamic panel discussions to identify policy and market-based solutions to some of California’s most significant economic and policy challenges.',
  },
];

export const First: RouteInfo[] = [
  {
    img: '../../../assets/images/corporatesustainingpartnerslogo/Tmobile.png',
    alt: 'T-Mobile Business Logo',
    href: 'https://www.t-mobile.com/about-us',
  },
  {
    img: '../../../assets/images/corporateMember/verizon.png',
    alt: 'Verizon Business Logo',
    href: 'https://www.verizon.com/about/our-company',
  },
  {
    img: '../../../assets/images/corporatePartnerLogo/CA Strawberry Commission Logo.jpg',
    alt: 'CA Strawberry Commission Business Logo',
    href: 'https://login.calstrawberry.com/',
  },
  {
    img: '../../../assets/images/corporateMember/Altria.jpeg',
    alt: 'Altria Business Logo',
    href: 'https://www.altria.com/en/about-altria',
  },
  {
    img: '../../../assets/images/corporatesustainingpartnerslogo/meta-logo.png',
    alt: 'Meta Business Logo',
    href: 'https://about.meta.com/?utm_source=about.facebook.com&utm_medium=redirect',
  },
  {
    img: '../../../assets/images/corporateMember/Sempra.png',
    alt: 'Sempra Business Logo',
    href: 'https://www.sempra.com/about',
  },
];

@Component({
    selector: 'app-legislative-and-economic-outlook',
    templateUrl: './legislative-and-economic-outlook.component.html',
    styleUrls: ['./legislative-and-economic-outlook.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LegislativeAndEconomicOutlookComponent implements OnInit {
  mainTitle = 'Legislative & Economic Outlook';
  lists: any = [];
  firsts: any = [];

  constructor() {}

  ngOnInit(): void {
    this.lists = LegislativeContent.filter((list) => list);
    this.firsts = First.filter((first) => first);
  }
}
